let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5PIwW")).then(() => parcelRequire('dmWJ4'));